import { OrderDeliveryType } from "@/types/orders";
import {
  OrderDeliveryCategoryInterface,
  OrderDeliveryInterface,
  OrderDriverInterface,
} from "@/interface/business/order.interface";
import { OrderDeliveryCategory, OrderDeliveryDriver } from "@/modules/orders/index";

/**
 * Delivery Category Class
 */
export default class OrderDelivery implements OrderDeliveryInterface {
  id: string = "";
  name: string = "";
  status: string = "";
  driver?: OrderDriverInterface | null;
  category?: OrderDeliveryCategoryInterface | null;

  constructor(data?: OrderDeliveryType) {
    Object.assign(this, data);
    if (data?.driver) {
      this.driver = new OrderDeliveryDriver(data.driver);
    }

    if (data?.category) {
      this.category = new OrderDeliveryCategory(data.category);
    }
  }
}
